/**
 * Provides an interface for modifying the field values in a `User` model.
 * @module directory/views/_Form
 */
import Backbone from "backbone";
import _ from "underscore";
import User from "app/models/User";
import Field from "core/models/Field";
import FormView from "core/views/FormView";
import ValueCollections from "app/models/ValueCollections";
import session from "app/Session";
export default Backbone.View.extend({
  events: {
    "change .uname": "_updateEmail",
    "keyup .uname": "_updateEmail",
    "change .first-name, .last-name": "_updateUsername",
    "keyup .first-name, .last-name": "_updateUsername",
  },

  _organizations: function () {
    return _.map(this.options.organizations, function (org) {
      return {
        value: org.id,
        text: org.get("PrimaryName"),
      };
    });
  },

  /**
   * Initializes the view.
   * @param  {object} options The options hash.
   * @param {User} options.model The user model associated with the view.
   * @param {Array} options.organizations An array of `Organization` models.
   * @param {app/Context} options.context The context associated with this view.
   */
  initialize: function (options) {
    this.options = options;

    this._validateModel = _.throttle(_.bind(this._validateModel, this), 250, {
      leading: false,
    });
  },

  render: function () {
    var organizations = this._organizations();
    var organizationMap = {};

    _.each(organizations, function (org) {
      organizationMap[org.value] = org.text;
    });
    var fields = [
      new Field(User.fields["PrimaryName"]).decorate({
        viewOptions: {
          className: "first-name",
        },
      }),
      new Field(User.fields["SecondaryName"]).decorate({
        viewOptions: {
          className: "last-name",
        },
      }),
      new Field(User.fields["Username"]).decorate({
        editor: "custom",
        EditorView: {
          template: _.template(
            '<input class="form-control uname" type="<%-type%>" name="<%-name%>" value="<%-value%>"/><span class="help-block" id="usernameBlock"></span>'
          ),

          events: {
            "change .form-control": "onChange",
            "keyup .form-control": "onChange",
          },

          getControlValue: function () {
            return this.$(".form-control").val();
          },

          setControlValue: function (value) {
            this.$(".form-control").val(value);
          },

          serialize: function () {
            var defaults = {
              type: "text",
              name: "",
              value: "",
            };

            return _.defaults(
              {},
              {
                type: this.field.get("editor"),
                name: this.field.id,
                value: this.getValue(""),
              },
              defaults
            );
          },
        },
        editable: this.options.model.isNew(),
      }),
      new Field(User.fields["EmailAddress"]).decorate({
        viewOptions: {
          className: "email",
        },
      }),
      new Field(User.fields["PhoneNumber"]),
      new Field({
        name: "Organization",
        label: "Organization",
        valueSource: ValueCollections.Organization,
        editable: session.hasRole("admin"),
      }),
      new Field(User.fields["Extension"]),
    ];

    var model = this.options.model;
    var view = (this.view = new FormView({
      model: model,
      fields: fields,
    }));

    model.on(
      "change:PrimaryName change:SecondaryName",
      this._updateUsername,
      this
    );
    model.on("change:Username", this._updateEmail, this);

    view.render();

    this.$el.html("<h2>" + _.escape(this.options.title) + "</h2>").append(view.$el);
    this.delegateEvents();

    this.$(".help-block").hide();
  },

  _updateUsername: function () {
    var model = this.options.model;
    var first = model.get("PrimaryName") || "";
    var last = model.get("SecondaryName") || "";
    var uname = first.substring(0, 1).toLowerCase() + last.toLowerCase();

    model.set("Username", uname);
  },

  _validateModel: function () {
    var uname = this.$(".uname");
    var usernameBlock = this.$("#usernameBlock");

    this.options.model.set("Username", uname.val());

    this.options.model.validate(function (err, data) {
      if (data.Username) {
        usernameBlock.html(data.Username);
        usernameBlock.show();
        uname.parent().addClass("has-error");
      } else {
        usernameBlock.hide();
        uname.parent().removeClass("has-error");
      }
    });
  },

  _updateEmail: function () {
    var model = this.options.model;

    model.set("EmailAddress", model.get("Username") + "@hbkengineering.com");

    this._validateModel();
  },
});



//////////////////
// WEBPACK FOOTER
// ./public/js/app/views/user/_Form.js
// module id = 871
// module chunks = 1